// extracted by mini-css-extract-plugin
export default {"wrapper":"DraftList_wrapper__geMaJ","notFound":"DraftList_notFound__q3Fea"};